/* eslint-disable no-unused-vars */
// There are unused vars because the types also act as docs

export interface LocationJsonLd {
  '@type': 'Place';
  name: string;
  address: {
    '@type': 'PostalAddress';
    streetAddress: string;
    addressLocality: string;
    postalCode: string;
    addressRegion: string;
    addressCountry: string;
  };
}

export interface OrganizerJsonLd {
  '@type': 'Organization';
  name: string;
  url?: string;
}

export interface PerformingGroup {
  '@type': 'PerformingGroup';
  name: string;
}

export interface Person {
  '@type': 'Person';
  name: string;
}

export const enum ItemAvailability {
  // There are more, but they are irrelevant for us
  InStock = 'https://schema.org/InStock',
  SoldOut = 'https://schema.org/SoldOut'
}

export interface OfferJsonLd {
  // Incomplete type
  '@type': 'Offer';
  url?: string;
  price: string | number;
  priceCurrency?: string;
  availability?: ItemAvailability;
  availabilityStarts?: string;
  availabilityEnds?: string;
  // Im not sure how this is different to the availability but Google uses it
  validFrom?: string;
  validThrough?: string;
}

export interface AggregateOfferJsonLd {
  '@type': 'AggregateOffer';
  highPrice?: number | string;
  lowPrice?: number | string;
  priceCurrency?: string;
  availability?: ItemAvailability;
  url?: string;
  offerCount: number;
  offers: OfferJsonLd[];
}

export const enum AttendanceMode {
  Mixed = 'https://schema.org/MixedEventAttendanceMode',
  Offline = 'https://schema.org/OfflineEventAttendanceMode',
  Online = 'https://schema.org/OnlineEventAttendanceMode'
}

export const enum EventStatus {
  Cancelled = 'https://schema.org/EventCancelled',
  MovedOnline = 'https://schema.org/EventMovedOnline',
  Postponed = 'https://schema.org/EventPostponed',
  Resheduled = 'https://schema.org/EventRescheduled',
  Scheduled = 'https://schema.org/EventScheduled'
}

export interface EventJsonLd {
  '@context': 'https://schema.org';
  '@type': 'Event';
  name: string;
  description: string;
  startDate: string;
  endDate: string;
  doorTime: string;
  eventAttendanceMode: AttendanceMode;
  eventStatus: EventStatus;
  location: LocationJsonLd;
  image: string[];
  offers: AggregateOfferJsonLd;
  organizer: OrganizerJsonLd;
  performer?: PerformingGroup | Person;
}
